import { render, staticRenderFns } from "./catalog_filter.vue?vue&type=template&id=4df0bcd8&"
import script from "./catalog_filter.vue?vue&type=script&lang=js&"
export * from "./catalog_filter.vue?vue&type=script&lang=js&"
import style0 from "./catalog_filter.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCheckbox } from 'vuetify/lib/components/VCheckbox';
installComponents(component, {VCheckbox})


/* hot reload */
if (module.hot) {
  var api = require("/home/eu/public_ru/local/templates/international/int_site/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('4df0bcd8')) {
      api.createRecord('4df0bcd8', component.options)
    } else {
      api.reload('4df0bcd8', component.options)
    }
    module.hot.accept("./catalog_filter.vue?vue&type=template&id=4df0bcd8&", function () {
      api.rerender('4df0bcd8', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/main/catalog_filter.vue"
export default component.exports